"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRenderFullContent = void 0;
// (C) 2007-2021 GoodData Corporation
var MINIMUM_LONGER_SIDE = 380;
var MINIMUM_SHORTER_SIDE = 200;
exports.shouldRenderFullContent = function (height, width) {
    if (!height || !width) {
        return false;
    }
    var shorter = Math.min(width, height);
    var longer = Math.max(width, height);
    return shorter >= MINIMUM_SHORTER_SIDE && longer >= MINIMUM_LONGER_SIDE;
};
//# sourceMappingURL=sizingUtils.js.map